import * as React from 'react';
import { useTeamAccountPlanDetailsQuery } from './useTeamAccountPlanDetailsQuery';
var defaultValue = {
    hasMaxBudgetsLimit: false,
    hasMaxMembersLimit: false,
    hasMaxAddPaymentMethodMonthlyLimit: false,
    hasMaxBudgetAmountLimit: false,
    maxBudgetsLimit: null,
    maxMembersLimit: null,
    maxAddPaymentMethodLimit: null,
    maxBudgetAmountLimit: null,
};
var TeamAccountConfigurationContext = React.createContext(defaultValue);
export var getLimitationsByLimitationType = function (data) {
    var limitationsByLimitationType = data === null || data === void 0 ? void 0 : data.teamAccountPlanDetails.planLimitations.reduce(function (accumulator, currentValue) {
        accumulator[currentValue.type] = currentValue;
        return accumulator;
    }, {});
    return limitationsByLimitationType;
};
var TeamAccountConfigurationProvider = function (props) {
    var _a = useTeamAccountPlanDetailsQuery(props.teamAccountId), data = _a.data, refetch = _a.refetch;
    var _b = getLimitationsByLimitationType(data) || {}, maxBudgetAmountLimit = _b.MAX_BUDGET_AMOUNT, maxBudgetsLimit = _b.MAX_BUDGETS_PER_TEAM_ACCOUNT, maxAddPaymentMethodLimit = _b.MAX_ADD_CARD_PAYMENT_ATTEMPTS_MONTHLY, maxMembersLimit = _b.MAX_MEMBERS_PER_TEAM_ACCOUNT;
    var value = {
        hasMaxBudgetsLimit: Boolean(maxBudgetsLimit === null || maxBudgetsLimit === void 0 ? void 0 : maxBudgetsLimit.limit),
        hasMaxMembersLimit: Boolean(maxMembersLimit === null || maxMembersLimit === void 0 ? void 0 : maxMembersLimit.limit),
        hasMaxAddPaymentMethodMonthlyLimit: Boolean(maxAddPaymentMethodLimit === null || maxAddPaymentMethodLimit === void 0 ? void 0 : maxAddPaymentMethodLimit.limit),
        hasMaxBudgetAmountLimit: Boolean(maxBudgetAmountLimit === null || maxBudgetAmountLimit === void 0 ? void 0 : maxBudgetAmountLimit.limit),
        maxBudgetsLimit: maxBudgetsLimit,
        maxMembersLimit: maxMembersLimit,
        maxAddPaymentMethodLimit: maxAddPaymentMethodLimit,
        maxBudgetAmountLimit: maxBudgetAmountLimit,
        reloadTeamAccountPlanDetails: refetch,
    };
    return (React.createElement(TeamAccountConfigurationContext.Provider, { value: value }, props.children));
};
var useTeamAccountConfigurationContext = function () {
    var context = React.useContext(TeamAccountConfigurationContext);
    return context;
};
export { TeamAccountConfigurationProvider, useTeamAccountConfigurationContext };
